import React, { useEffect } from 'react'
import { useForm } from '@inertiajs/react'

import { toast } from 'react-toastify'

import Layout from '@/Shared/Layout'
import BreadCrumbs from '@/Shared/BreadCrumbs'

import Form from '@/Pages/Users/Shared/Form'

const Create = () => {
    const { data, setData, errors, post, processing } = useForm({
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: '1',
        hospital_id: null
    })

    useEffect(() => {
        Object.values(errors).map(error => {
            toast.error(error)
        })
    }, [errors])

    function handleSubmit(e) {
        e.preventDefault()
        post(route('users.store'))
    }

    return (
        <div>
            <BreadCrumbs link="users" title="Users" subTitle="Create" />

            <h1 className="mb-8 text-3xl font-bold">Create User</h1>

            <div className="max-w-3xl overflow-y-visible rounded bg-white p-8 shadow">
                <h1 className="text-2xl font-semibold">User Form</h1>

                <Form
                    data={data}
                    errors={errors}
                    processing={processing}
                    setData={setData}
                    handleSubmit={handleSubmit}
                />
            </div>
        </div>
    )
}

Create.layout = page => <Layout title="Create User" children={page} />

export default Create
